var exports = {
  "kL": "xdbfd91f1--d5e43a--container",
  "dR": "xdbfd91f1--d5e43a--animation--scale",
  "Sg": "xdbfd91f1--d5e43a--opened",
  "SW": "xdbfd91f1--d5e43a--animation--opacity",
  "jc": "xdbfd91f1--d5e43a--animation--toggle_bottom",
  "Qs": "xdbfd91f1--d5e43a--content",
};

module.exports = exports;
